import VueUeditorWrap from 'vue-ueditor-wrap'

const contractMixin = {
  components: {
    VueUeditorWrap
  },
  data() {
    return {
      cardOptions: [],
      saveLoading: false,
      submitLoading: false,
      myConfig: {
        // 如果需要上传功能,找后端小伙伴要服务器接口地址
        // serverUrl: this.$config.baseUrl + 'ueditor/ueditorConfig',
        serverUrl: this.getAppConfig().fwbUrl,
        // 你的UEditor资源存放的路径,相对于打包后的index.html
        UEDITOR_HOME_URL: '/UEditor/',
        // 编辑器不自动被内容撑高
        autoHeightEnabled: true,
        // 工具栏是否可以浮动
        autoFloatEnabled: false,
        // 初始容器高度
        initialFrameHeight: 640,
        // 初始容器宽度
        initialFrameWidth: 700,//a4纸张的宽度
        // 关闭自动保存
        enableAutoSave: false,
        editorInstance: undefined,
        wordCount: false,//是否开启字数统计
        elementPathEnabled: false,//是否启用元素路径
        showSeal: false
      },
      //位置修正信息
      fixPosition: {
        x: 0,
        y: 57//编辑框高度
      },
      superviseLocation: {
        codeXCoordinate: 0,
        codeYCoordinate: 0,
        qrCodeXCoordinate: 0,
        qrCodeYCoordinate: 0
      },
      contractTemplateType: this.$route.query.contractTemplateType
    }
  },
  mounted() {
    this.getPactSignCardType()
  },
  activated() {
    this.$store.commit('UPDATE_PAY_CONTRACT', true)
  },
  methods: {
    ready(editorInstance) {
      this.editorInstance = editorInstance
      console.log('editorInstance==', editorInstance)
    },
    //富文本禁止编辑
    disableEditor(editorInstance) {
      this.editorInstance = editorInstance
      editorInstance.execCommand('drafts')
      editorInstance.setDisabled()
      console.log('editorInstance==', editorInstance)
    },
    getPactSignCardType() {
      let url = 'pact/getPactSignCardType'
      this.getHttpServices().getServerApiService().get(url).then(list => {
        this.cardOptions = list
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onDraggingEvent(x, y, item, index) {
      if (x >= 0 && y >= 0) {
        item.signXCoordinate = x
        item.signYCoordinate = y
      }
    },
    onDraggingDateEvent(x, y, item, index) {
      if (x >= 0 && y >= 0) {
        item.dateXCoordinate = x
        item.dateYCoordinate = y
      }
    },
    onDraggingContractCodeEvent(x, y) {
      if (x >= 0 && y >= 0) {
        this.getLogUtils().logWithTag('合同编码X轴', x)
        this.getLogUtils().logWithTag('合同编码Y轴', y)
        this.superviseLocation.codeXCoordinate = x
        this.superviseLocation.codeYCoordinate = y
      }
    },
    onDraggingQrcodeEvent(x, y) {
      if (x >= 0 && y >= 0) {
        this.getLogUtils().logWithTag('二维码编码X轴', x)
        this.getLogUtils().logWithTag('二维码编码Y轴', y)
        this.superviseLocation.qrCodeXCoordinate = x
        this.superviseLocation.qrCodeYCoordinate = y
      }
    },
    /**
     * 获取签署项
     * @param signatoryList
     * @returns {*[]|*}
     */
    getSignatoryList(signatoryList) {
      if (signatoryList && signatoryList.length > 0) {
        //签署项
        return signatoryList.map(item => {
          const code = (item.signType === 1 || item.signType === '1') ? item.socialCreditCode : item.cardNumber
          return {
            name: item.signName,
            signType: item.signType,
            automatic: item.automatic,
            cardType: item.cardType,
            phoneNumber: item.sendMobile,
            code: code ? code : undefined,
            signXCoordinate: item.signXCoordinate ? Number.parseInt(item.signXCoordinate) + this.fixPosition.x : 0,
            signYCoordinate: item.signYCoordinate ? Number.parseInt(item.signYCoordinate) + this.fixPosition.y : this.fixPosition.y,
            dateXCoordinate: item.dateXCoordinate ? Number.parseInt(item.dateXCoordinate) + this.fixPosition.x : 0,
            dateYCoordinate: item.dateYCoordinate ? Number.parseInt(item.dateYCoordinate) + this.fixPosition.y : this.fixPosition.y
          }
        })
      }
      return []
    },
    getSuperviseLocation(data) {
      if (data) {
        this.superviseLocation.codeXCoordinate = data.codeXCoordinate ? Number.parseInt(data.codeXCoordinate) : 0
        this.superviseLocation.codeYCoordinate = data.codeYCoordinate ? Number.parseInt(data.codeYCoordinate) : 0
        this.superviseLocation.qrCodeXCoordinate = data.qrCodeXCoordinate ? Number.parseInt(data.qrCodeXCoordinate) : 0
        this.superviseLocation.qrCodeYCoordinate = data.qrCodeYCoordinate ? Number.parseInt(data.qrCodeYCoordinate) : 0
        this.getLogUtils().logWithTag('getSuperviseLocation', this.superviseLocation)
      }
    },
    paginationFunction(pageSize, currentPage, arr) {
      let skipNum = (currentPage - 1) * pageSize
      let newArr = (skipNum + pageSize >= arr.length) ? arr.slice(skipNum, arr.length) : arr.slice(skipNum, skipNum + pageSize)
      return newArr
    }
  }
}
export default contractMixin
